import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CSSPlugin from 'gsap/CSSPlugin';
gsap.registerPlugin(ScrollTrigger, CSSPlugin);

//
import Swiper from 'swiper';
import { Autoplay, Pagination, Scrollbar, Navigation, EffectCoverflow } from 'swiper/modules';
Swiper.use([Autoplay, Pagination, Scrollbar, Navigation, EffectCoverflow]);

window.addEventListener("load", function () {

	const swiperParam = {
		loop: true,
		slidesPerView: 1,
		autoHeight: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		    },
		/*autoplay: {
			delay: 0,
		},
		speed: 15000,
		initialSlide: 2,*/
	}
	const swiperMain = new Swiper('.avsystem__post-contents__slide .swiper', swiperParam);

	const thumb_item = document.querySelectorAll('.thumb li');
	thumb_item.forEach(function (value, index) {
		value.addEventListener('click', function (event) {
			//value.classList.remove('active');
			swiperMain.slideTo(index);

		});

	});
	swiperMain.on('slideChange', function () {
		thumb_item.forEach(function (value, index) {
			value.classList.remove('active');
		});
		thumb_item[swiperMain.activeIndex].classList.add('active');;
	});


});
